import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { BlockedUsersLink } from "Pages/People/BlockedUsersLink";
import { FollowersSection } from "Pages/People/FollowersSection";
import { UserSearchOverlay } from "Pages/People/UserSearchOverlay";
import { Resources, useResource } from "Translations/Resources";
import { canRoleBeFollowed } from "Utils/Social/socialRules";

/**
 * The social page of a business persona (Merchant, Hunter, HunterPlus). It follows nobody
 * (Social ADR-0002), so a Merchant's side of the graph is just the customers who follow it — one
 * list, no tabs. Hunters can't be followed at all (Rules v2, K3), so for them the page is people
 * search only, titled accordingly. People search stays for everyone: it leads to profiles and to
 * Send message, which business personas can use. PeoplePage redirects them here; the side menu
 * links here directly.
 */
export const FollowersPage = () => {
  const { t } = useResource();
  const isFollowable = canRoleBeFollowed(useCurrentUserAccessRole());

  return (
    <AuthenticatedLayout
      title={t(
        isFollowable
          ? Resources.Pages.Titles.Followers
          : Resources.Pages.Titles.People,
      )}
    >
      <StyledPageWrapper>
        <Stack className="left-content" gap={2} mb={6}>
          <UserSearchOverlay
            placeholder={t(Resources.Social.People.SearchAllUsersPlaceholder)}
          />
          {isFollowable && (
            <FollowersSection
              heading={t(Resources.Social.People.Tabs.Followers)}
            />
          )}
          <BlockedUsersLink />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
